
const savingBuilderSetting = () => {
  return 'Saving...'
}

export default savingBuilderSetting